import { render, staticRenderFns } from "./editorladder.vue?vue&type=template&id=9e4e1f08"
import script from "./editorladder.vue?vue&type=script&lang=js"
export * from "./editorladder.vue?vue&type=script&lang=js"
import style0 from "./editorladder.vue?vue&type=style&index=0&id=9e4e1f08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports